import { p as promiseResolve, b as bootstrapLazy } from './index-8d9e9a23.js';

/*
 Stencil Client Patch Esm v2.0.3 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["gnx-onboarding",[[0,"gnx-onboarding",{"infoPageOne":[8,"info-page-one"],"data":[8],"background":[1],"page":[32],"index":[32],"getActiveIndex":[64]},[[0,"ionSlideNextStart","handlerIonSlideNextStart"],[0,"ionSlidePrevStart","handlerIonSlidePrevStart"],[0,"ionSlideDidChange","handlerIonSlideDidChange"]]]]],["my-component",[[1,"my-component",{"first":[1],"middle":[1],"last":[1]}]]]], options);
  });
};

export { defineCustomElements };
